module.exports = __webpack_public_path__ + "static/images/audio-logo.3024661.png";